import { Loader2 } from 'lucide-react';
import { cn } from '@/shared/utils/cn';

/** Single shared spinner — replaces the ad-hoc per-screen spinners. */
export const Spinner = ({ className }: { className?: string }) => (
  <Loader2 className={cn('h-4 w-4 animate-spin', className)} aria-hidden />
);
